/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Form, Grid } from '@mairistem/composants';

import { AssistantContext } from '@/contexts';

import { Steps } from '@/types';
import SituationFamiliale from './SituationFamiliale';
import InformationsNaissance from './InformationsNaissance';
import Recensement from './Recensement';

const StepIdentification = () => {
  const {
    adresseNaissance,
    sexe,
    nomFamille,
    nomUsage,
    prenom,
    prenomsComplementaires,
    heureNaissance,
    minuteNaissance,
    jourNaissance,
    moisNaissance,
    anneeNaissance,
    typeDateNaissance,
    anneeRecensement,
    dateRecensement,
    demandeExemption,
    nombreEnfants,
    nombreFreresSoeurs,
    pupille,
    recensement,
    situationFamiliale,
    trimestreRecensement,
    onChange,
    exemptionActive,
    errors,
  } = React.useContext(AssistantContext);

  const individu = React.useMemo(
    () => ({
      adresseNaissance,
      sexe,
      nomFamille,
      nomUsage,
      prenom,
      prenomsComplementaires,
      heureNaissance,
      minuteNaissance,
      jourNaissance,
      moisNaissance,
      anneeNaissance,
      typeDateNaissance,
      anneeRecensement,
      dateRecensement,
      demandeExemption,
      exemptionActive,
      nombreEnfants,
      nombreFreresSoeurs,
      pupille,
      recensement,
      situationFamiliale,
      trimestreRecensement,
    }),
    [
      adresseNaissance,
      sexe,
      nomFamille,
      nomUsage,
      prenom,
      prenomsComplementaires,
      heureNaissance,
      minuteNaissance,
      jourNaissance,
      moisNaissance,
      anneeNaissance,
      typeDateNaissance,
      anneeRecensement,
      dateRecensement,
      demandeExemption,
      nombreEnfants,
      nombreFreresSoeurs,
      pupille,
      recensement,
      situationFamiliale,
      trimestreRecensement,
      exemptionActive,
    ],
  );

  const errorsStep = errors?.[Steps.Identification] || {};

  return (
    <Grid padded as={Form}>
      <Grid.Row style={{ paddingTop: '0px' }}>
        <Grid.Column>
          <InformationsNaissance
            individu={individu}
            errors={errorsStep}
            onChange={onChange}
            dateRecensement={dateRecensement}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row style={{ paddingTop: '0px' }}>
        <Grid.Column mobile={16} computer={8}>
          <SituationFamiliale
            situationFamiliale={situationFamiliale}
            nombreEnfants={nombreEnfants}
            nombreFreresSoeurs={nombreFreresSoeurs}
            pupille={pupille}
            errors={errorsStep}
            onChange={onChange}
          />
        </Grid.Column>
        <Grid.Column mobile={16} computer={8}>
          <Recensement
            anneeRecensement={anneeRecensement}
            dateRecensement={dateRecensement}
            demandeExemption={demandeExemption}
            recensement={recensement}
            trimestreRecensement={trimestreRecensement}
            exemptionActive={exemptionActive}
            errors={errorsStep}
            onChange={onChange}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default StepIdentification;
